module.exports = __webpack_public_path__ + "img/letter-seal.3b1cdc1e.png";